<template>
  <div class="menu-icon" :class="classes">
    <div class="menu-icon__bar menu-icon__bar--1" :class="lineClasses"></div>
    <div class="menu-icon__bar menu-icon__bar--2" :class="lineClasses"></div>
    <div class="menu-icon__bar menu-icon__bar--3" :class="lineClasses"></div>
  </div>
</template>

<script>
export default {
  name: "M4MenuIcon",
  props: ["variant", "menuOpen"],
  computed: {
    classes() {
      let classes = [];
      if (this.menuOpen) {
        classes.push("menu-icon--open");
      }
      return classes;
    },
    lineClasses() {
      let classes = [];
      if (this.variant) {
        classes.push("menu-icon__bar--" + this.variant);
      }
      if (this.menuOpen) {
        classes.push("menu-icon__bar--open");
      }
      return classes;
    }
  }
};
</script>

<style scoped></style>
